import { unpack, rnd2, rnd3 } from '../../utils/index.js';
var oklch2css = function oklch2css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var lcha = unpack(args, 'lch');
  lcha[0] = rnd2(lcha[0] * 100) + '%';
  lcha[1] = rnd3(lcha[1]);
  lcha[2] = isNaN(lcha[2]) ? 'none' : rnd2(lcha[2]) + 'deg'; // add deg unit to hue
  if (lcha.length > 3 && lcha[3] < 1) {
    lcha[3] = '/ ' + (lcha.length > 3 ? lcha[3] : 1);
  } else {
    lcha.length = 3;
  }
  return "oklch(".concat(lcha.join(' '), ")");
};
export default oklch2css;